export enum MessageModifiers {
    Change = "change",
    Accepted = "accepted-bet",
    Tax = "tax",
    Purchase = "purchase"
}